'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSettingsVoice = function MdSettingsVoice(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 16.6c0 5.7-4.5 10.5-10 11.3v5.5h-3.2v-5.5c-5.5-0.8-10-5.6-10-11.3h2.8c0 5 4.2 8.6 8.8 8.6s8.8-3.6 8.8-8.6h2.8z m-6.6 23.4v-3.4h3.4v3.4h-3.4z m-6.6 0v-3.4h3.2v3.4h-3.2z m1.6-18.4c-2.7 0-5-2.2-5-5v-10c0-2.7 2.3-5 5-5s5 2.3 5 5v10c0 2.8-2.3 5-5 5z m-8.4 18.4v-3.4h3.4v3.4h-3.4z' })
        )
    );
};

exports.default = MdSettingsVoice;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/settings-voice.js
// module id = 1959
// module chunks = 168707334958949